import { CarouselProps } from "@bluframe/blublocks"

import Carousel from "./Carousel"

export interface Props extends CarouselProps {
  // Props
}

export interface ComponentProps extends Props {
  // ComponentProps
}

export default Carousel
